import OrderAdditionalInfo from './OrderAdditionalInfo';
const AdditionalInfoSection = ({ type, orderDetails, controllerProps }) => (
  <>
    {type !== 'DetailsPurchaseOrdersIpb' &&
      type !== 'DetailsFailedTransactions' &&
      type !== 'DetailsVinculationOrders' && (
        <OrderAdditionalInfo
          labelSimType={controllerProps.purchase}
          type={type}
          title={
            type === 'detailsHistoryPrepaid'
              ? 'Fechas de Transacción'
              : type === 'detailsSimIpb'
                ? 'Fechas de Transacción'
                : type === 'AiraloDetails'
                  ? 'Resumen de compra'
                  : 'Información del Pago'
          }
          orderDetails={orderDetails}
        />
      )}
  </>
);
export default AdditionalInfoSection;
